<template>
    <aside class="footer grid" v-if="showPartial">
        <div class="grid--container">
            <div class="footer--row">
                <div class="footer--col" v-for="(plugin, index) in plugins"
                        v-if="!isMobile || !plugin.content.hide_on_mobile">
                    <div class="footer--section-wrapper">
                        <component :is="viewportDependentWrapper"
                                :is-active="accordionStates[index]"
                                :passive-mode="true"
                                @request-change="updateState(index, $event)">

                            <!-- head -->
                            <template slot="head" slot-scope="props">
                                <span class="footer--section-header"
                                        :class="[props.isActive ? 'footer--section-header__is-open' : '']">
                                    <h2 class="u-reset footer--section-title"
                                            v-text="plugin.content.title">
                                    </h2>
                                    <cmp-icon v-if="isMobile"
                                            class="footer--section-icon"
                                            symbol="navigation_mobile_down"
                                            size="x-small">
                                    </cmp-icon>
                                </span>
                            </template>

                            <!-- body -->
                            <component slot="body" :is="plugin.type" :plugin="plugin"></component>

                        </component>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
    import simpleWrapperComponent from './simple-wrapper';
    import { toNumeral, numerals } from 'util/dom/mq';
    import cmsPartial from 'vue/mixins/cms/cms-partial';
    import { mapGetters } from 'vuex';


    export default {
        mixins: [cmsPartial],
        data() {
            return {
                accordionStates: [],
            };
        },
        computed: {
            ...mapGetters(['viewport']),
            isMobile() {
                return toNumeral(this.viewport.mq.query) < numerals.MD;
            },
            viewportDependentWrapper() {
                return this.isMobile ? 'cmp-accordion' : simpleWrapperComponent;
            },
        },
        methods: {
            updateState(updateIdx, updateVal) {
                if (updateVal) {
                    this.accordionStates.forEach((item, idx) => {
                        if (updateIdx === idx) {
                            return;
                        }

                        this.accordionStates.splice(idx, 1, false);
                    });
                }

                this.accordionStates.splice(updateIdx, 1, updateVal);
            },
        },
        watch: {
            plugins: {
                handler(plugins) {
                    if (plugins.length <= this.accordionStates.length) {
                        return;
                    }

                    plugins.forEach((plugin, idx) => {
                        this.accordionStates[idx] = this.accordionStates[idx] || false;
                    });
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?360707a2